export enum ExecutionStatusEnum {
    TODO,
    IN_PROGRESS,
    DONE,
    CANCELED,
    ON_ERROR,
}
export default ExecutionStatusEnum
